module.exports = __webpack_public_path__ + "1a9713da32b4983e5525570f2081e98a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/modern-glass-house.png
// module id = 582
// module chunks = 0